var map = {
	"./taro-audio-core.entry.js": [
		184,
		106
	],
	"./taro-block-core.entry.js": [
		185,
		107
	],
	"./taro-button-core.entry.js": [
		186,
		91
	],
	"./taro-camera-core.entry.js": [
		187,
		108
	],
	"./taro-canvas-core.entry.js": [
		188,
		109
	],
	"./taro-checkbox-core_2.entry.js": [
		189,
		110
	],
	"./taro-cover-image-core.entry.js": [
		190,
		111
	],
	"./taro-cover-view-core.entry.js": [
		191,
		112
	],
	"./taro-form-core.entry.js": [
		192,
		113
	],
	"./taro-icon-core.entry.js": [
		193,
		92
	],
	"./taro-image-core.entry.js": [
		194,
		93
	],
	"./taro-input-core.entry.js": [
		195,
		114
	],
	"./taro-label-core.entry.js": [
		196,
		115
	],
	"./taro-moveable-area-core.entry.js": [
		197,
		116
	],
	"./taro-moveable-view-core.entry.js": [
		198,
		117
	],
	"./taro-navigator-core.entry.js": [
		199,
		94
	],
	"./taro-open-data-core.entry.js": [
		200,
		118
	],
	"./taro-picker-core_2.entry.js": [
		201,
		95
	],
	"./taro-picker-view-column-core.entry.js": [
		202,
		119
	],
	"./taro-picker-view-core.entry.js": [
		203,
		120
	],
	"./taro-progress-core.entry.js": [
		204,
		121
	],
	"./taro-pull-to-refresh.entry.js": [
		205,
		96
	],
	"./taro-radio-core_2.entry.js": [
		206,
		122
	],
	"./taro-rich-text-core.entry.js": [
		207,
		123
	],
	"./taro-scroll-view-core.entry.js": [
		208,
		97
	],
	"./taro-slider-core.entry.js": [
		209,
		124
	],
	"./taro-swiper-core_2.entry.js": [
		210,
		98
	],
	"./taro-switch-core.entry.js": [
		211,
		125
	],
	"./taro-tabbar.entry.js": [
		212,
		99
	],
	"./taro-text-core.entry.js": [
		213,
		100
	],
	"./taro-textarea-core.entry.js": [
		214,
		126
	],
	"./taro-video-control_3.entry.js": [
		215,
		101
	],
	"./taro-view-core.entry.js": [
		216,
		102
	],
	"./taro-web-view-core.entry.js": [
		217,
		127
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 87;
module.exports = webpackAsyncContext;